module.exports = "https://www.gc-pro.gnp.com.mx/de526048b1d8a711a6f2ec750fea4935.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/arrow_left.png
// module id = 935
// module chunks = 0 1